/**
 * Generated runtime TestId mirror for frontend/src/components/shared/BeneficiaryMultiSelect.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const BeneficiaryMultiSelectTestIds = {
  beneficiaryChips: "beneficiary-chips",
  beneficiaryChip: (chip_id: string) => `beneficiary-chip-${chip_id}`,
  beneficiaryChipPrefix: () => "beneficiary-chip-" as TestIdPrefix
} as const;
